import { Component, Input, OnInit, AfterViewInit, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-service-offerings-flowchart',
  template: `
    <div class="flowchart-container">
      <div class="flowchart-wrapper">
        <!-- Root Node -->
        <div class="root-node">
          <div class="node-content">Service Offerings</div>
        </div>
        
        <!-- Level 1 Nodes -->
        <div class="level1-nodes">
          <div class="level1-node" *ngFor="let service of serviceOfferings; let i = index">
            <div class="node-content">{{ service.name }}</div>
            <div class="arrow-down">↓</div>
          </div>
        </div>
        
        <!-- Level 2 Nodes -->
        <div class="level2-nodes">
          <div class="level2-node" *ngFor="let service of serviceOfferings; let i = index">
            <div class="node-content">{{ service.description }}</div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .flowchart-container {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 2rem;
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
      border-radius: 20px;
      box-shadow: 0 8px 24px rgba(0,0,0,0.08);
      border: 1px solid rgba(28,62,138,0.1);
    }
    
    .flowchart-wrapper {
      width: 100%;
      max-width: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
    }
    
    .root-node {
      background: #1c3e8a;
      color: white;
      padding: 1.5rem 3rem;
      border-radius: 12px;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
      box-shadow: 0 4px 12px rgba(28,62,138,0.3);
      min-width: 200px;
    }
    
    .level1-nodes {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1.5rem;
      width: 100%;
      align-items: stretch;
    }
    
    .level1-node {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      flex: 1;
      min-width: 150px;
      max-width: 200px;
      height: 100%;
      position: relative;
    }
    
    .level1-node .node-content {
      background: #2c5aa0;
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 8px;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      box-shadow: 0 3px 8px rgba(44,90,160,0.3);
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 80px;
    }
    
    .arrow-down {
      color: #1c3e8a;
      font-size: 24px;
      font-weight: bold;
      position: relative;
      z-index: 2;
    }
    
    .level1-node::after {
      content: '';
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 12px solid #1c3e8a;
      z-index: 1;
    }
    
    .level2-nodes {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1.5rem;
      width: 100%;
      align-items: stretch;
    }
    
    .level2-node {
      flex: 1;
      min-width: 150px;
      max-width: 200px;
      height: 100%;
      position: relative;
    }
    
    .level2-node .node-content {
      background: #f8f9fa;
      color: #1c3e8a;
      padding: 1rem 1.5rem;
      border-radius: 8px;
      font-weight: 500;
      font-size: 13px;
      text-align: center;
      border: 1px solid #2c5aa0;
      box-shadow: 0 2px 6px rgba(0,0,0,0.1);
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100px;
    }
    
    .node-content {
      word-wrap: break-word;
      white-space: normal;
      line-height: 1.4;
    }
    
    @media (max-width: 768px) {
      .level1-nodes, .level2-nodes {
        flex-direction: column;
        align-items: center;
      }
      
      .level1-node, .level2-node {
        max-width: 100%;
        width: 100%;
      }
      
      .root-node {
        padding: 1rem 2rem;
        font-size: 16px;
      }
    }
  `]
})
export class ServiceOfferingsFlowchartComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() chartDefinition: string = '';

  serviceOfferings = [
    {
      name: 'Solution Design & Engineering',
      description: 'User-friendly, secure, high-performance applications.'
    },
    {
      name: 'Integration Services',
      description: 'Seamless connection with ERP, CRM, analytics, and enterprise platforms.'
    },
    {
      name: 'Workflow Automation',
      description: 'AI-powered tools and RPA for faster, smarter processes.'
    },
    {
      name: 'Mobile-First Development',
      description: 'Real-time access across devices for modern workforces.'
    },
    {
      name: 'DevOps & Cloud Enablement',
      description: 'Streamlined delivery pipelines and scalable deployments.'
    }
  ];

  ngOnInit() {
    // Component initialization
  }

  ngAfterViewInit() {
    // Component ready
  }

  ngOnChanges(changes: SimpleChanges) {
    // Handle input changes if needed
  }
}
